import { db, auth } from "../utils/firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import UserListing from "./UserListing";
import LogOutButton from "./LogOutButton";
import VisibilityButton from "./VisibilityButton";

export default function BoardMemberPage({ user }) {
  const {
    name: { family_name, given_name },
    userTypeName,
    email_address,
    community,
    address,
  } = user;

  const [newFirstName, setNewFirstName] = useState(given_name);
  const [newLastName, setNewLastName] = useState(family_name);
  const [newAddress, setNewAddress] = useState(address);
  // const [newPhoneNumber, setNewPhoneNumber] = useState("");

  const userCommunityChanger = doc(db, "Users", auth.currentUser.uid);
  const [newCommunity, setNewCommunity] = useState(community);
  const [communitiesList, setCommunitiesList] = useState([]);
  const [detailsVis, setDetailsVis] = useState(true);
  const [roleAssignmentVis, setRoleAssignmentVis] = useState(true);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    async function changeCommunity() {
      await updateDoc(userCommunityChanger, { community: newCommunity });
    }
    changeCommunity();
  }, [newCommunity]);

  const [queryState, setQueryState] = useState({
    isLoading: true,
    errorMessage: "",
    docSnapshots: null,
  });

  useEffect(() => {
    async function getUsers() {
      try {
        setQueryState({
          isLoading: true,
          errorMessage: "",
          docSnapshots: null,
        });
        const querySnapshot = await getDocs(collection(db, "Users"));
        const docs = querySnapshot.docs;
        setQueryState({
          isLoading: false,
          errorMessage: "",
          docSnapshots: docs,
        });
      } catch (error) {
        setQueryState({
          isLoading: false,
          errorMessage: "Error",
          docSnapshots: null,
        });
        console.log(error);
      }
    }
    async function getCommunities() {
      const q = await getDocs(collection(db, "Communities"));

      setCommunitiesList(
        q.docs.map((doc) => {
          return doc.data().name;
        })
      );
    }
    getCommunities();

    getUsers();
  }, []);

  const updateUser = async () => {
    await updateDoc(userCommunityChanger, {
      name: {
        family_name: newLastName,
        given_name: newFirstName,
      },
      // address: newAddress,
      // phoneNumber: newPhoneNumber,
    });
    setNewFirstName(newFirstName);
    setNewLastName(newLastName);
    // setNewAddress(newAddress);
    // setNewPhoneNumber(newPhoneNumber);
  };

  const { isLoading, errorMessage, docSnapshots } = queryState;

  let content;

  if (isLoading) {
    content = "Loading...";
  } else if (errorMessage) {
    content = errorMessage;
  } else {
    content = (
      <UserListing data={docSnapshots} level={3} community={community} />
    );
  }

  return (
    <div className="bg-user-home text-center">
      <h1>My Dashboard</h1>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <div id="myDetails" className="round-border">
              {editing ? (
                <>
                  <label>First Name:</label>
                  {"  "}
                  <input
                    type="text"
                    placeholder="First Name"
                    defaultValue={newFirstName}
                    onChange={(e) => setNewFirstName(e.target.value)}
                  />
                  <br />
                  <label>
                    <span>Last Name:</span>
                  </label>
                  {"  "}
                  <input
                    type="text"
                    placeholder="Last Name"
                    defaultValue={newLastName}
                    onChange={(e) => setNewLastName(e.target.value)}
                  />
                  <p>
                    <span>Role:</span> {userTypeName}
                  </p>
                  <p>
                    <span>Email:</span> {email_address}
                  </p>
                  {/* <label>
                    <span>Address:</span>
                  </label>
                  {"  "} */}
                  {/* <input
                    type="address"
                    placeholder="Address"
                    defaultValue={newAddress}
                    onChange={(e) => setNewAddress(e.target.value)}
                    style={{ textAlign: "center", minWidth: "350px" }}
                  />
                  <br />
                  <label>Phone Number</label>
                  {"  "}
                  <input
                    type="tel"
                    placeholder="Phone Number"
                    defaultValue={newPhoneNumber}
                    onChange={(e) => setNewPhoneNumber(e.target.value)}
                  /> */}
                  <button
                    onClick={() => {
                      setEditing(!editing);
                      updateUser();
                    }}
                    className="btn btn-primary"
                  >
                    Save
                  </button>
                </>
              ) : (
                <>
                  <div className="profileDetailsWrapper">
                    <div className="profileDetails">
                      <b>Name:</b> {newFirstName} {newLastName}
                    </div>
                    <div className="profileDetails">
                      <span>Role:</span> {userTypeName}
                    </div>
                    <div className="profileDetails">
                      <span>Email:</span> {email_address}
                    </div>
                    {/* <div className="profileDetails">
                      <span>Address:</span> {newAddress}
                    </div> */}
                    {/* <div className="profileDetails">
                      <span>Phone Number: {newPhoneNumber}</span>
                    </div> */}
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setEditing(!editing);
                      }}
                    >
                      Edit Info
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="col-md-8">{content}</div>
        </div>
      </div>

      <LogOutButton />
    </div>
  );
}
